import { p as proxyCustomElement, H, c as createEvent, h, d as Host } from './p-bfa0dc67.js';
import { c as classNames } from './p-df8c8ec2.js';

const biAccordionCss = ".sr-only{position:absolute;height:1px;width:1px;padding:0;margin:-1px;overflow:hidden;border:0;left:-9999px;text-indent:-5000px;clip:rect(1px, 1px, 1px, 1px);}*,*:before,*:after{box-sizing:border-box}html,body,div,span,object,iframe,figure,h1,h2,h3,h4,h5,h6,p,blockquote,pre,a,code,em,img,small,strike,strong,sub,sup,tt,b,u,i,ol,ul,li,fieldset,form,label,table,caption,tbody,tfoot,thead,tr,th,td,main,canvas,embed,footer,header,nav,section,button,video{margin:0;padding:0;border:0;font-size:100%;font:inherit;vertical-align:baseline;text-rendering:optimizeLegibility;-webkit-font-smoothing:antialiased;text-size-adjust:none}footer,header,nav,section,main{display:block}body{line-height:1.5}ol,ul{list-style:none}blockquote,q{quotes:none}blockquote:before,blockquote:after,q:before,q:after{content:\"\";content:none}table{border-collapse:collapse;border-spacing:0}input{-webkit-appearance:none;appearance:none;border-radius:0}:host(:focus){outline:none !important;border:none !important}:host{display:flex;width:100%;justify-content:center;align-items:center;flex-direction:column;color:#414651}:host(.left){align-self:start}@media (max-width: 768px){:host(.left){align-self:unset;justify-content:center;margin:auto}}:host(.center){justify-content:center;margin:auto}:host(.right){align-self:end}@media (max-width: 768px){:host(.right){align-self:unset;justify-content:center;margin:auto}}:host(.smallWidth){max-width:520px}:host(.mediumWidth){max-width:720px}:host(.largeWidth){max-width:1440px}.accordion{display:flex;flex-direction:column;font-family:inherit;font-size:inherit;line-height:inherit;width:100%;background-color:white;border-radius:4px;font-family:\"museo-sans\", arial, sans-serif, sans-serif;font-size:1rem;line-height:1.5;padding:24px}.accordion.noPadding{padding:0}.accordion.blueSubtle{background-color:#cfebff}.accordion.goldMuted{background-color:#fff7e3}.accordion.grayMuted{background-color:whitesmoke}.accordion.small{font-size:0.75rem;line-height:1.5}.accordion.medium{font-size:1rem;line-height:1.5}.accordion.large{font-size:1.25rem;line-height:1.5}.accordion.border{border:1px solid #ccc}";
const BiAccordionStyle0 = biAccordionCss;

const BiAccordion$1 = /*@__PURE__*/ proxyCustomElement(class BiAccordion extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.toggleAccordion = createEvent(this, "toggle", 7);
        this.openAccordion = createEvent(this, "open", 7);
        this.closeAccordion = createEvent(this, "close", 7);
        this.accordionGroup = null;
        this.accordionHeader = null;
        this.accordionContent = null;
        /**
         * Determines if the accordion is expanded or not.
         * @default false
         */
        this.isExpanded = false;
        /**
         * Background color of the accordion.
         */
        this.backgroundColor = 'blueSubtle';
        /**
         * Width of the accordion element.
         * @default 'medium'
         */
        this.width = 'medium';
        /**
         * Indicates if the accordion should have a border.
         * @default false
         */
        this.border = false;
        /**
         * Should the accordion be expanded by default.
         * @default false
         */
        this.defaultExpanded = false;
        /**
         * Remove the padding in the accordion.
         * @default false
         */
        this.noPadding = false;
        /**
         * Alignment of the accordion content.
         * @default 'center'
         */
        this.alignment = 'center';
    }
    async toggle() {
        this.isExpanded = !this.isExpanded;
        if (this.accordionGroup.collapse === 'single' && this.defaultExpanded === false) {
            this.accordionGroup?.closeAll(this.el);
        }
    }
    async open() {
        this.isExpanded = true;
    }
    async close() {
        this.isExpanded = false;
    }
    isExpandedChanged() {
        this.accordionHeader?.updateIsExpanded();
        this.accordionContent?.updateIsExpanded();
        if (this.isExpanded) {
            this.openAccordion.emit();
        }
        else {
            this.closeAccordion.emit();
        }
        this.toggleAccordion.emit({ expanded: this.isExpanded });
    }
    componentWillLoad() {
        const parent = this.el.parentElement;
        this.accordionGroup = parent.tagName === 'BI-ACCORDION-GROUP' && parent;
        this.accordionHeader = this.el.querySelector('bi-accordion-header');
        this.accordionContent = this.el.querySelector('bi-accordion-content');
        if (this.defaultExpanded === true) {
            this.isExpanded = true;
        }
    }
    render() {
        return (h(Host, { key: '09446c06ed4f251b358a2ac77551a39ce271060e', class: classNames('host', this.alignment, `${this.width}Width`) }, h("div", { key: '569626cd98ba938f2486fdb9b0dd2b34eef16307', class: classNames('accordion', this.backgroundColor, { border: this.border }, this.noPadding && 'noPadding') }, h("slot", { key: '173e4d7675d5f3a4cbc1623fc7fad81f6958247e' }))));
    }
    get el() { return this; }
    static get watchers() { return {
        "isExpanded": ["isExpandedChanged"]
    }; }
    static get style() { return BiAccordionStyle0; }
}, [1, "bi-accordion", {
        "isExpanded": [1028, "is-expanded"],
        "backgroundColor": [1, "background-color"],
        "width": [1],
        "border": [4],
        "defaultExpanded": [4, "default-expanded"],
        "noPadding": [4, "no-padding"],
        "alignment": [1],
        "toggle": [64],
        "open": [64],
        "close": [64]
    }, undefined, {
        "isExpanded": ["isExpandedChanged"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["bi-accordion"];
    components.forEach(tagName => { switch (tagName) {
        case "bi-accordion":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, BiAccordion$1);
            }
            break;
    } });
}

const BiAccordion = BiAccordion$1;
const defineCustomElement = defineCustomElement$1;

export { BiAccordion, defineCustomElement };
